import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=7bb212a8&scoped=true&"
import script from "./Live.vue?vue&type=script&lang=js&"
export * from "./Live.vue?vue&type=script&lang=js&"
import style0 from "./Live.vue?vue&type=style&index=0&id=7bb212a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb212a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb212a8')) {
      api.createRecord('7bb212a8', component.options)
    } else {
      api.reload('7bb212a8', component.options)
    }
    module.hot.accept("./Live.vue?vue&type=template&id=7bb212a8&scoped=true&", function () {
      api.rerender('7bb212a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Live.vue"
export default component.exports